import { $ as jquery } from 'jquery';

var $ = jquery;
var jQuery = jquery;

if (typeof window !== 'undefined') {
  window.layui = window.layui || {};
  window.layui.jquery = window.layui.jquery || $;
  window.$ = window.$ || $;
  window.jQuery = window.jQuery || $;
}

var jqzoom = (function () {
  (function ($) {
    var DEFAULTS = {
      xzoom: 200,
      yzoom: 200,
      offset: 10,
      position: 'right',
      lens: 1,
      preload: 1,
      responsiveBreakpoint: 768,
    };
    var INSTANCE_KEY = 'layui.jqzoom.instance';

    function getInstance(element) {
      return $(element).data(INSTANCE_KEY) || null;
    }

    function destroyInstance(element) {
      var instance = getInstance(element);
      if (instance && typeof instance.destroy === 'function') {
        instance.destroy();
      }
    }

    function JqZoom(element, options) {
      this.$root = $(element);
      this.settings = $.extend({}, DEFAULTS, options || {});
      this.ns = '.jqzoom_' + Math.random().toString(36).slice(2, 10);
      this.$img = this.$root.children('img').eq(0);
      this.$viewer = $();
      this.$viewerImg = $();
      this.$lens = $();
      this.currentLargeSrc = '';
      this.originalAlt = this.$img.attr('alt') || '';
      this.active = false;
      this.disabled = false;
      this.init();
    }

    JqZoom.prototype.init = function () {
      if (!this.$root.length || !this.$img.length) {
        return;
      }

      this.$root.addClass('layui-jqzoom');
      this.preload();
      this.bind();
      this.$root.data(INSTANCE_KEY, this);
    };

    JqZoom.prototype.bind = function () {
      var instance = this;

      this.$root.on('mouseenter' + this.ns, function () {
        instance.activate();
      });

      this.$root.on('mousemove' + this.ns, function (event) {
        instance.handlePointerMove(event);
      });

      this.$root.on('mouseleave' + this.ns, function () {
        instance.deactivate();
      });

      this.$root.on('touchstart' + this.ns, function () {
        instance.deactivate();
      });

      $(window).on('resize' + this.ns, function () {
        instance.syncResponsiveState();
        if (instance.active) {
          instance.positionViewer();
        }
      });

      this.syncResponsiveState();
    };

    JqZoom.prototype.syncResponsiveState = function () {
      this.disabled = window.innerWidth <= this.settings.responsiveBreakpoint;
      if (this.disabled) {
        this.deactivate();
      }
    };

    JqZoom.prototype.preload = function () {
      var largeSrc = this.getLargeSrc();
      if (this.settings.preload && largeSrc) {
        $('<img />').attr('src', largeSrc);
      }
    };

    JqZoom.prototype.getLargeSrc = function () {
      return this.$img.attr('jqimg') || this.$img.attr('src') || '';
    };

    JqZoom.prototype.ensureViewer = function () {
      var largeSrc;

      if (this.$viewer.length) {
        return;
      }

      largeSrc = this.getLargeSrc();
      this.currentLargeSrc = largeSrc;
      this.$viewer = $('<div class="layui-jqzoom-viewer"><img class="layui-jqzoom-viewer-image" alt="" /></div>');
      this.$viewerImg = this.$viewer.find('img');
      this.$viewerImg.attr('src', largeSrc);
      this.$lens = $('<div class="layui-jqzoom-lens" aria-hidden="true"></div>');
      this.$root.append(this.$lens);
      $('body').append(this.$viewer);
    };

    JqZoom.prototype.activate = function () {
      if (this.disabled || !this.$img.length || !this.$img[0].complete) {
        return;
      }

      this.ensureViewer();
      this.updateLargeImage();
      this.positionViewer();
      this.$viewer.show();

      if (this.settings.lens) {
        this.$lens.show();
      } else {
        this.$root.css('cursor', 'crosshair');
        this.$lens.hide();
      }

      this.$img.attr('alt', '');
      this.active = true;
    };

    JqZoom.prototype.deactivate = function () {
      this.active = false;
      this.$img.attr('alt', this.originalAlt);
      this.$root.css('cursor', '');
      if (this.$lens.length) {
        this.$lens.hide();
      }
      if (this.$viewer.length) {
        this.$viewer.hide();
      }
    };

    JqZoom.prototype.updateLargeImage = function () {
      var largeSrc = this.getLargeSrc();
      if (!largeSrc) {
        return;
      }
      if (largeSrc !== this.currentLargeSrc) {
        this.currentLargeSrc = largeSrc;
        this.$viewerImg.attr('src', largeSrc);
      }
    };

    JqZoom.prototype.positionViewer = function () {
      var rect;
      var pageX;
      var pageY;
      var left;
      var top;
      var fitsRight;

      if (!this.$viewer.length) {
        return;
      }

      rect = this.$root[0].getBoundingClientRect();
      pageX = rect.left + window.pageXOffset;
      pageY = rect.top + window.pageYOffset;
      fitsRight = rect.right + this.settings.offset + this.settings.xzoom <= window.innerWidth;

      if (this.settings.position === 'left' || !fitsRight) {
        left = pageX - this.settings.offset - this.settings.xzoom;
        if (left < window.pageXOffset + 8) {
          left = pageX + rect.width + this.settings.offset;
        }
      } else {
        left = pageX + rect.width + this.settings.offset;
      }

      top = pageY;

      this.$viewer.css({
        top: top,
        left: left,
        width: this.settings.xzoom,
        height: this.settings.yzoom,
      });
    };

    JqZoom.prototype.handlePointerMove = function (event) {
      var imageRect;
      var largeImage;
      var largeWidth;
      var largeHeight;
      var scaleX;
      var scaleY;
      var lensWidth;
      var lensHeight;
      var relativeX;
      var relativeY;
      var lensLeft;
      var lensTop;

      if (!this.active || !this.$img.length || !this.$viewerImg.length) {
        return;
      }

      imageRect = this.$img[0].getBoundingClientRect();
      largeImage = this.$viewerImg[0];
      largeWidth = largeImage.naturalWidth || largeImage.width || this.$img[0].naturalWidth || imageRect.width;
      largeHeight = largeImage.naturalHeight || largeImage.height || this.$img[0].naturalHeight || imageRect.height;

      if (!largeWidth || !largeHeight || !imageRect.width || !imageRect.height) {
        return;
      }

      scaleX = largeWidth / imageRect.width;
      scaleY = largeHeight / imageRect.height;
      lensWidth = this.settings.xzoom / scaleX;
      lensHeight = this.settings.yzoom / scaleY;
      relativeX = event.clientX - imageRect.left;
      relativeY = event.clientY - imageRect.top;

      relativeX = Math.max(0, Math.min(relativeX, imageRect.width));
      relativeY = Math.max(0, Math.min(relativeY, imageRect.height));

      lensLeft = relativeX - lensWidth / 2;
      lensTop = relativeY - lensHeight / 2;

      lensLeft = Math.max(0, Math.min(lensLeft, imageRect.width - lensWidth));
      lensTop = Math.max(0, Math.min(lensTop, imageRect.height - lensHeight));

      if (this.settings.lens) {
        this.$lens.css({
          width: lensWidth,
          height: lensHeight,
          left: lensLeft,
          top: lensTop,
        });
      }

      this.$viewer.scrollLeft(lensLeft * scaleX);
      this.$viewer.scrollTop(lensTop * scaleY);
    };

    JqZoom.prototype.destroy = function () {
      this.deactivate();
      this.$root.off(this.ns).removeData(INSTANCE_KEY);
      $(window).off(this.ns);
      if (this.$lens.length) {
        this.$lens.remove();
      }
      if (this.$viewer.length) {
        this.$viewer.remove();
      }
      this.$root.removeClass('layui-jqzoom');
    };

    $.fn.jqzoom = function (options) {
      return this.each(function () {
        destroyInstance(this);
        new JqZoom(this, options);
      });
    };
  })(jQuery);

  return $.fn.jqzoom;
})();

if (typeof window !== 'undefined') {
  window.layui = window.layui || {};
  window.layui.jqzoom = jqzoom;
  if (window.jQuery) {
    window.jQuery.fn.jqzoom = $.fn.jqzoom;
    window.jQuery.fn.jqueryzoom = $.fn.jqzoom;
  }
}

export { jqzoom };
